/* eslint-disable jsx-a11y/interactive-supports-focus,jsx-a11y/click-events-have-key-events */
// @flow
import { LozengeGroup, Lozenge } from '@ansarada/ace-react';
import React from 'react';
import styles from './styles.scss';

type Item = {
  key: string,
  label: string,
};

type Props = {
  items: Array<Item>,
  selected: string,
  className?: string,
  onSelect: string => void,
};

const MaceLozenge = (props: Props) => {
  const { items, selected, className, onSelect } = props;
  return (
    <LozengeGroup className={className}>
      {items.map(({ key, label }) => (
        //  $FlowFixMe
        <button
          key={key}
          className={styles.lozengeBtn}
          // role="button"
          onClick={() => onSelect(key)}
          data-testid={`lozenge-${label.replace(/ /g, '-')}`}
        >
          <Lozenge
            className={styles.lozenge}
            text={label}
            backgroundColor={key === selected ? '#C9FB00' : undefined}
            textColor="black"
          />
        </button>
      ))}
    </LozengeGroup>
  );
};

export default MaceLozenge;
